/**
 * Dropdown ricercabile generico: input con filtro live + lista opzioni
 * filtrate, chiusura su mousedown esterno. Estratto da RegolePage (era
 * locale al builder di regole) perche' riusato anche da EtichettePicker
 * come riferimento di pattern DOM (contenitore relative + pannello
 * assoluto).
 */

import React, { useEffect, useRef, useState } from 'react';
import { Input } from '@floraltech/ui';

export interface Option {
  value: string;
  label: string;
}

export function SearchSelect({
  id,
  options,
  value,
  onChange,
  placeholder,
}: {
  id: string;
  options: Option[];
  value: string;
  onChange: (v: string) => void;
  placeholder?: string;
}) {
  const [aperto, setAperto] = useState(false);
  const [filtro, setFiltro] = useState('');
  const boxRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const chiudi = (e: MouseEvent) => {
      if (boxRef.current && !boxRef.current.contains(e.target as Node)) {
        setAperto(false);
        setFiltro('');
      }
    };
    document.addEventListener('mousedown', chiudi);
    return () => document.removeEventListener('mousedown', chiudi);
  }, []);

  const selezionata = options.find((o) => o.value === value);
  const visibili = options.filter((o) =>
    o.label.toLowerCase().includes(filtro.toLowerCase())
  );

  return (
    <div className="relative" ref={boxRef}>
      <Input
        id={id}
        value={aperto ? filtro : (selezionata?.label ?? '')}
        placeholder={placeholder ?? 'Cerca...'}
        onFocus={() => {
          setAperto(true);
          setFiltro('');
        }}
        onChange={(e: React.ChangeEvent<HTMLInputElement>) => setFiltro(e.target.value)}
        autoComplete="off"
      />
      {aperto && (
        <ul className="absolute z-20 mt-1 max-h-48 w-full overflow-auto rounded-md border bg-background shadow">
          {visibili.length === 0 && (
            <li className="px-3 py-2 text-xs text-muted-foreground">Nessun risultato</li>
          )}
          {visibili.map((o) => (
            <li key={o.value}>
              <button
                type="button"
                className={`w-full px-3 py-2 text-left text-sm hover:bg-muted ${
                  o.value === value ? 'font-medium' : ''
                }`}
                onClick={() => {
                  onChange(o.value);
                  setAperto(false);
                  setFiltro('');
                }}
              >
                {o.label}
              </button>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
